import BankAccountTutorial from '@/components/bank-account/tutorial/index';

export default BankAccountTutorial;
